module.exports = __webpack_public_path__ + "img/6.3-实现港口管理统一化协作.32ff1a91.png";